import { app } from '../../../../app';
import { Controller } from './application-info.controller';

app.component('companyApplicationInfo', {
    bindings: {
        account: '<',
        appType: '<',
        companyId: '<',
        appPermissions: '<',
    },
    controller: Controller,
    templateUrl: require('./application-info.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/application-info/application-info.component.js